/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Anchor = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "12", cy: "5", r: "3" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "8" }],
    ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3" }]
  ]
];

export { Anchor as default };
//# sourceMappingURL=anchor.js.map
